import { useAppContext } from '@/App.context'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import useSubscriptionServices from '@/hooks/subscriptionServices'

import { Translation } from '../i18n/Translation'

const SalaryDeductionSubServices = ({ invoice }: any) => {
  const subscriptionServices = useSubscriptionServices()

  if (!invoice) return null

  const activeSubServices = subscriptionServices?.filter(
    service => new Date(service.activated) < new Date(invoice.date)
  )

  // @ts-ignore
  if (!invoice || activeSubServices.length <= 0) return null

  return (
    <>
      <div className="post sub-service private-purchase type0 visible">
        <div className="type_header">
          <Translation id="Private kjøp" />
          <div className="type_sub_header">
            <Translation id="Ikke mulig å søke refusjon" />
          </div>
        </div>
      </div>

      <div className="private-purchase-posts">
        {/* @ts-ignore */}
        {activeSubServices.map((service, idx) => (
          <SalaryDeductionService key={idx} {...service} />
        ))}
      </div>
    </>
  )
}

const SalaryDeductionService = ({ name, price }: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <div className="post sub-service type0 private-purchase visible">
      <div className="list_item visible">
        <div className={'color color color2 ' + whiteLabel} />

        <div className="sda">
          {' '}
          <FormattedNumberWithCurrency amount={price} precision={2} />
        </div>

        <div className="desc">
          <Translation id="Privat" />
        </div>

        <div className="prod">{name}</div>
      </div>
    </div>
  )
}

export default SalaryDeductionSubServices
